import { useMemo } from 'react';
import { useTranslation } from '@hotjar/translations';
import { getTargetedUsers } from '../../../common/Wizard/common/targeting';
import type { TargetEntry } from '../../../common/Wizard/common/targeting';

export const useTargetingUsers = (targeting: TargetEntry[] | undefined): string | undefined => {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-wizard-summary' });
  return useMemo(() => {
    if (targeting === undefined) return undefined;
    const userRules = getTargetedUsers(targeting);
    return userRules.length > 0 ? t('specific-users', { count: userRules.length }) : t('all-users');
  }, [t, targeting]);
};
